// src/components/SEO.js
import React from "react";
import { Helmet } from "react-helmet";

const SEO = ({ title, description, keywords, image, url }) => {
  const siteName = "Tesseract Flex Fuel";
  const defaultTitle = `${siteName} — Sustainable Biodiesel Manufacturer`;
  const fullTitle = title ? `${siteName} — ${title}` : defaultTitle;
  const fullDescription =
    description ||
    "Tesseract Flex Fuel is India’s next-generation biodiesel and flex fuel manufacturer driving sustainable energy solutions.";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={fullDescription} />
      {keywords && <meta name="keywords" content={keywords} />}

      {/* Open Graph Tags */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDescription} />
      <meta property="og:url" content={url || "https://www.tesseractflexfuel.com/"} />
      <meta property="og:site_name" content={siteName} />
      {image && <meta property="og:image" content={image} />}

      {/* Twitter Card (optional) */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDescription} />
      {image && <meta name="twitter:image" content={image} />}

      {/* Other site-related metadata */}
      <meta name="application-name" content={siteName} />

      {/* Canonical URL */}
      <link rel="canonical" href={url || "https://www.tesseractflexfuel.com/"} />
    </Helmet>
  );
};

export default SEO;
